const OKTA_CONFIG = {
  authorize: {
    issuer: process.env.REACT_APP_OKTA_AUTH_ISSUER,
    clientId: process.env.REACT_APP_OKTA_AUTH_CLIENTID,
    responseMode: 'fragment',
    tokenManager: {
      storage: 'localStorage',
      autoRenew: true
    },
    redirectUri: `${window.location.protocol}//${window.location.host}/okta-redirect`,
    maxClockSkew: 600
  },
  token: {
    responseType: ['code'],
    scopes: ['openid', 'profile', 'offline_access']
  },
  ccOrgAuthorize: {
    issuer: process.env.REACT_APP_OKTA_CC_ORG_AUTHORIZE_ISSUER,
    url: process.env.REACT_APP_OKTA_CC_ORG_AUTHORIZE_URL
  },
  idps: {
    okta: process.env.REACT_APP_OKTA_IDPS_OKTA,
    adesa: process.env.REACT_APP_OKTA_IDPS_ADESA
  },
  selfServicePortal: process.env.REACT_APP_SELF_SERVICE_PORTAL,
  oktaTokenStorage: 'okta-token-storage'
};

export const accessTokenStructurePlaceholder = {
  scopes: OKTA_CONFIG.token.scopes,
  accessToken: 'PLACEHOLDER',
  tokenType: 'Bearer',
  authorizeUrl: `${OKTA_CONFIG.authorize.issuer}/v1/authorize`,
  userinfoUrl: `${OKTA_CONFIG.authorize.issuer}/v1/userinfo`,
  expiresAt: 12345
};

export const refreshTokenStructurePlaceholder = {
  tokenUrl: `${OKTA_CONFIG.authorize.issuer}/v1/token`,
  scopes: OKTA_CONFIG.token.scopes,
  issuer: `${OKTA_CONFIG.authorize.issuer}`,
  authorizeUrl: `${OKTA_CONFIG.authorize.issuer}/v1/authorize`,
  expiresAt: 12345
};

export default OKTA_CONFIG;
